import React, { useEffect } from 'react';
import { TitledContainer } from '../../../../components/TitledContainer/TitledContainer';
import { DeployabilityOverviewContainer } from './DeployabilityOverviewContainer';

const DeployabilityPage: React.FC = () => {
  useEffect(() => {
    document.title = 'Logistics | Inzetbaarheid';
  }, []);

  return (
    <>
      <TitledContainer title='Inzetbaarheid'>
        <DeployabilityOverviewContainer />
      </TitledContainer>
    </>
  );
};

export { DeployabilityPage };
